import {
  ActionReducerMap,
  createFeatureSelector,
  createSelector, MemoizedSelector,
} from '@ngrx/store';
import * as _ from 'lodash';
import * as fromRoot from '../../shared/reducers';
import {CompaniesListReducer, companiesListSelectors, CompaniesState} from './companies-list';
import {CompaniesFilter, CompaniesList} from '../models/companies-list';
import {CompanyReducer, companySelectors, CompanyState} from './company';
import {Company} from '../models/company';
import {InvoicesPreviewReducer, invoicesPreviewSelectors, InvoicesPreviewState} from './invoice-preview';

export interface CompaniesStates {
  companiesList: CompaniesState;
  company: CompanyState;
  invoicesPreview: InvoicesPreviewState;
}

export interface AppState extends fromRoot.AppState {
  companies: CompaniesStates;
}

export const reducers: ActionReducerMap<CompaniesStates> = {
  companiesList: CompaniesListReducer,
  company: CompanyReducer,
  invoicesPreview: InvoicesPreviewReducer,
};

const getCompanyState = createFeatureSelector('companies');

const rootSelectors = {
  companiesList: createSelector(getCompanyState, (state: CompaniesStates) => _.get(state, 'companiesList')),
  company: createSelector(getCompanyState, (state: CompaniesStates) => _.get(state, 'company')),
  invoicesPreview: createSelector(getCompanyState, (state: CompaniesStates) => _.get(state, 'invoicesPreview')),
};

export interface Selectors {
  getCompanyFilter: MemoizedSelector<AppState, CompaniesFilter |  string | number>;
  getCompanyQuickSearch: MemoizedSelector<AppState, string>;
  getCompanyBy: MemoizedSelector<AppState, string>;
  getCompanies: MemoizedSelector<AppState, CompaniesList[]>;
  getCompanyCount: MemoizedSelector<AppState, number>;
  getCompanyPageSize: MemoizedSelector<AppState, number>;
  getCompanyPage: MemoizedSelector<AppState, number>;
  getCompanyShowFilter: MemoizedSelector<AppState, boolean>;

  getCompany: MemoizedSelector<AppState, Company>;
  // tslint:disable-next-line:no-any
  getInvoicesPreview: MemoizedSelector<AppState, any>;
}

export const selectors: Selectors = {
  getCompanyFilter: createSelector(rootSelectors.companiesList, companiesListSelectors.filter),
  getCompanyQuickSearch: createSelector(rootSelectors.companiesList, companiesListSelectors.quickSearch),
  getCompanyBy: createSelector(rootSelectors.companiesList, companiesListSelectors.orderBy),
  getCompanies: createSelector(rootSelectors.companiesList, companiesListSelectors.array),
  getCompanyCount: createSelector(rootSelectors.companiesList, companiesListSelectors.count),
  getCompanyPageSize: createSelector(rootSelectors.companiesList, companiesListSelectors.pageSize),
  getCompanyPage: createSelector(rootSelectors.companiesList, companiesListSelectors.page),
  getCompanyShowFilter: createSelector(rootSelectors.companiesList, companiesListSelectors.showFilter),

  getCompany: createSelector(rootSelectors.company, companySelectors.company),
  getInvoicesPreview: createSelector(rootSelectors.invoicesPreview, invoicesPreviewSelectors.invoicesPreview),


};

